import { Clock, Globe, type LucideIcon, TrendingUp, Users } from "lucide-react";
import { useTranslations } from "next-intl";

interface StatCard {
  icon: LucideIcon;
  value: string;
  label: string;
}

const iconMap = [TrendingUp, Clock, Users, Globe];

export function StatsGrid() {
  const t = useTranslations();
  const stats = t.raw("login.stats");

  return (
    <div className="grid grid-cols-2 gap-4 mb-4">
      {stats.map((stat: StatCard, index: number) => {
        const Icon = iconMap[index];
        return (
          <div
            key={stat.label}
            className="bg-white/10 text-white backdrop-blur-sm rounded-2xl p-4 shadow-lg border border-white/10"
          >
            <Icon className="w-5 h-5" />
            <div className="text-2xl font-bold mt-2">{stat.value}</div>
            <div className="text-xs">{stat.label}</div>
          </div>
        );
      })}
    </div>
  );
}
